<template>
    <v-card :id="id" class="mt-3">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        ></psi-card-heading>
        <v-card-text>
            <div class="d-flex align-center mt-2">
                <h3>Result Action:</h3>
                <v-chip color="secondary" class="ml-2">{{
                    scorecard.result
                }}</v-chip>
            </div>
            <v-divider class="mt-2"></v-divider>

            <v-data-table
                :headers="headers"
                :items="items"
                disable-pagination
                disable-sort
                hide-default-footer
            >
                <template v-slot:item.Processed="{ item }">
                    <v-icon
                        :color="
                            item.Processed
                                ? 'warning darken-2'
                                : 'grey lighten-2'
                        "
                        >mdi-check-circle</v-icon
                    >
                </template>
                <template v-slot:item.Description="{ item }">
                    <psi-popover open-on-hover>
                        {{ item.Description }}
                    </psi-popover>
                </template>
                <template v-slot:item.Match="{ item }">
                    <v-icon
                        :color="
                            item.Match ? 'primary darken-2' : 'grey lighten-2'
                        "
                        >mdi-check-circle</v-icon
                    >
                </template>
                <template v-slot:item.Value="{ item }">
                    {{ item.Value }} {{ item.Unit }}
                </template>
                <template v-slot:item.Actions="{ item }">
                    <psi-action-drop-down
                        :items="menu"
                        icon="mdi-dots-vertical"
                        iconClass="primary--text"
                        heading="Scorecard Rule Actions"
                        @action="ruleAction($event, item)"
                    ></psi-action-drop-down>
                </template>
            </v-data-table>
        </v-card-text>
        <v-dialog v-model="actionDialog" max-width="800" v-if="actionDialog">
            <screening-process-edit-rule
                :rule="rule"
                @close="actionDialog = false"
            ></screening-process-edit-rule>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    name: "screening-process-scorecard",
    components: {
        ScreeningProcessEditRule: () => import("./ScreeningProcessEditRule"),
    },
    props: {
        id: {
            type: String,
            required: false,
            default: "screening-scorecard",
        },
        title: {
            type: String,
            required: false,
            default: "Score Card",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-clipboard-list-outline",
        },
        scorecard: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            actionDialog: false,
            rule: {},
            menu: [
                {
                    icon: "mdi-playlist-edit",
                    title: "Edit Rule",
                },
            ],
            // TODO: create a header class
            headers: [
                {
                    text: "Processed",
                    align: "center",
                    value: "Processed",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Matched",
                    align: "center",
                    value: "Match",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Category",
                    align: "start",
                    value: "category",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Section",
                    align: "start",
                    value: "Setting",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Value",
                    align: "start",
                    value: "Value",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Result",
                    align: "start",
                    value: "Action",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Description",
                    align: "start",
                    value: "Description",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Actions",
                    align: "center",
                    value: "Actions",
                    class:
                        "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
            ],
        };
    },
    computed: {
        items() {
            let items = [];
            for (const category in this.scorecard.scorecard) {
                this.scorecard.scorecard[category].rules.forEach((rule) => {
                    items.push({
                        ...rule,
                        category,
                    });
                });
            }
            return items;
        },
    },
    methods: {
        ruleAction(action, item) {
            if (action.title == "Edit Rule") {
                this.rule = item;
                this.actionDialog = true;
            }
        },
    },
};
</script>

<style scoped>
</style>